import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import CalculatorPage from './components/CalculatorPage';
import { calculators } from './data/calculators';

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-900 to-purple-800 relative overflow-hidden">
      {/* Background gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30 pointer-events-none"></div>
      
      <Router>
        <Routes>
          <Route path="/" element={<HomePage calculators={calculators} />} />
          <Route path="/:calculatorId" element={<CalculatorPage calculators={calculators} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;